import { useSearchParams } from '../../../hooks';
import { shiftStartParam } from '../../../config/queryParams';
export var useSwapPageQueryParams = function () {
    var searchParams = useSearchParams()[0];
    var shiftStart = searchParams.get(shiftStartParam);
    return { shiftStart: shiftStart };
};
